var _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1408,
    height: 593,
    viewBox: "0 0 1408 593",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_349_430)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 1400,
    height: 585,
    rx: 50,
    fill: "url(#paint0_linear_349_430)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_349_430",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 1400,
    height: 585
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 1400,
    height: 585,
    rx: 50,
    fill: "url(#paint1_linear_349_430)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_349_430)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.509,
    cy: 297.539,
    rx: 292.509,
    ry: 297.539,
    transform: "matrix(0.86744 -0.497541 0.53725 0.843423 417 -159.93)",
    fill: "url(#paint2_linear_349_430)",
    fillOpacity: 0.44,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 265.977,
    cy: 260.665,
    rx: 265.977,
    ry: 260.665,
    transform: "matrix(0.255312 -0.966859 0.971175 0.238366 1021 717.325)",
    fill: "url(#paint3_linear_349_430)",
    fillOpacity: 0.42,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 265.977,
    cy: 260.665,
    rx: 265.977,
    ry: 260.665,
    transform: "matrix(0.30883 -0.951117 0.956372 0.292152 -178 927.951)",
    fill: "url(#paint4_linear_349_430)",
    fillOpacity: 0.42,
    style: {
      mixBlendMode: "multiply"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_349_430",
    x: 0,
    y: 0,
    width: 1408,
    height: 593,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_349_430"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_349_430",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_349_430",
    x1: 298.833,
    y1: -0.0000290267,
    x2: 1277.24,
    y2: 750.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB901"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B871FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_349_430",
    x1: 298.833,
    y1: -0.0000290267,
    x2: 1277.24,
    y2: 750.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#684FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B871FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_349_430",
    x1: 292.509,
    y1: 0,
    x2: 292.509,
    y2: 595.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB901"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_349_430",
    x1: 265.977,
    y1: 0,
    x2: 265.977,
    y2: 521.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB901"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_349_430",
    x1: 265.977,
    y1: 0,
    x2: 265.977,
    y2: 521.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB901"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8F0",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/Background.95f71f93b8405d069a39a5316ba5cbd6.svg";
export { ForwardRef as ReactComponent };